// import { Routes, Route, Navigate } from "react-router-dom";
// import Home from "./pages/Home";
// import Profile from "./pages/Profile";
// import Register from "./pages/Register";
// import OTPSent from "./pages/OTPSent";
// import Offer from "./pages/Offer";
// import SingleOffer from "./pages/singleOffer";
// import About from "./pages/About";
// import Charity from "./pages/Charity";
// import Donation from "./pages/Donation";
// import DonationPayment1 from "./pages/DonationPayment1";
// import DonationPayment2 from "./pages/DonationPayment2";
// import DonationPaymentRazorpay from "./pages/DonationPaymentRazorpay";
// import DonationSpecial from "./pages/DonationSpecial";
// import Volunteering from "./pages/Volunteer";
// import NotFound from "./pages/NotFound";
// import DevelopersNotFound from "./pages/DevelopersNotFound";
// import Dashboard from "./pages/Dashboard";
// import Account from "./pages/Account";
// import EditPersonalInfo from "./pages/EditPersonalInfo";
// import EditAddress from "./pages/EditAddress";
// import Security from "./pages/Security";
// import CustomerSupport from "./pages/CustomerSupport";
// import LoyaltyCardProfile from "./pages/LoyaltyCardProfile";
// import PaymentPage from "./pages/PaymentPage";
// import Transaction from "./pages/Transaction";
// import Business from "./pages/Business/Business";
// import BusinessDashboard from "./pages/Business/Dashboard";
// // import BusinessProfile from "./pages/Business/BusinessProfile"; // [DEPRECATED]
// import BusinessProfileStores from "./pages/Business/BusinessProfileStores";
// import BusinessAddStore from "./pages/Business/BusinessAddStore";
// import BusinessProfileStoreEdit from "./pages/Business/BusinessProfileStoreEdit";
// import OffersManagement from "./pages/Business/OffersManagement";
// import Feedback from "./pages/Business/Feedback";
// import BusinessTransaction from "./pages/Business/Transaction";
// import QrCodeBusiness from "./components/QrCodeBusiness";
// import QrScannerBusiness from "./components/QrScannerBusiness";
// import BusinessEditProfile from "./components/BusinessEditProfile";
// import BusinessManageMedia from "./components/BusinessManageMedia";
// import AdminLayout from "./pages/Admin/AdminLayout";
// import DashboardAdmin from "./pages/Admin/DashboardAdmin";
// import TransactionsAdmin from "./pages/Admin/TransactionsAdmin";
// import AccountsAdmin from "./pages/Admin/AccountsAdmin";
// import ServicesAdmin from "./pages/Admin/ServicesAdmin";
// import PrivilegesAdmin from "./pages/Admin/PrivilegesAdmin";
// import SettingsAdmin from "./pages/Admin/SettingsAdmin";
// import CharityManagement from "./pages/Admin/CharityManagement";
// import RecommendedBrands from "./pages/RecommendedBrands";
// import CustomerInsights from "./pages/Business/CustomerInsights";
// import ContactSupport from "./pages/Business/ContactSupport";
// import BusinessInfo from "./pages/Business/BusinessInfo";
// import Login from "./components/Login";
// import SubaccountsManagement from "./pages/Business/SubaccountsManagement";
// import SubaccountProfile from "./pages/Business/SubaccountProfile";
// import EventManagement from "./pages/Business/EventManagement";
// import PaymentSuccess from "./pages/PaymentSuccess";
// import PaymentFailure from "./pages/PaymentFailure";
// import StorePage from "./pages/StorePage";
// import Rewards from "./pages/Rewards";
// import SuggestStore from "./pages/SuggestStore";

// import VolunteerLayout from "./pages/volunteer/volunteerLayout";
// import VolunteerDashboard from "./pages/volunteer/volunteerDashboard";
// import VolunteerStores from "./pages/volunteer/volunteerStores";
// import VolunteerProfile from "./pages/volunteer/volunteerProfile";
// import ProtectedBusinessRoute from "./components/ProtectedBusinessRoute";

// const AppRoute = () => {
// 	return (
// 		<Routes>
// 			<Route path="/business" element={<Business />}>
// 				<Route index element={<BusinessDashboard />} />
// 				{/* <Route path="profile" element={<BusinessProfile />} />  // [DEPRECATED] */}
// 				<Route path="stores" element={
// 					<ProtectedBusinessRoute allowedRoles={['Admin', 'Manager']}>
// 						<BusinessProfileStores />
// 					</ProtectedBusinessRoute>
// 				} />
// 				<Route path="stores/add" element={
// 					<ProtectedBusinessRoute allowedRoles={['Admin', 'Manager']}>
// 						<BusinessAddStore />
// 					</ProtectedBusinessRoute>
// 				} />
// 				<Route
// 					path="stores/edit/:storeId"
// 					element={
// 						<ProtectedBusinessRoute allowedRoles={['Admin', 'Manager']}>
// 							<BusinessProfileStoreEdit />
// 						</ProtectedBusinessRoute>
// 					}
// 				/>
// 				<Route path="offers" element={
// 					<ProtectedBusinessRoute allowedRoles={['Admin', 'Manager']}>
// 						<OffersManagement />
// 					</ProtectedBusinessRoute>
// 				} />
// 				<Route path="feedback" element={<Feedback />} />
// 				<Route path="transactions" element={<BusinessTransaction />} />
// 				<Route path="insights" element={
// 					<ProtectedBusinessRoute allowedRoles={['Admin', 'Manager']}>
// 						<CustomerInsights />
// 					</ProtectedBusinessRoute>
// 				} />
// 				<Route path="contact" element={<ContactSupport />} />
// 				<Route path="info" element={
// 					<ProtectedBusinessRoute ownerOnly>
// 						<BusinessInfo />
// 					</ProtectedBusinessRoute>
// 				} />
// 				<Route path="qr-code/:offerId" element={<QrCodeBusiness />} />
// 				<Route path="qr-scanner" element={<QrScannerBusiness />} />
// 				<Route path="edit-profile" element={
// 					<ProtectedBusinessRoute ownerOnly>
// 						<BusinessEditProfile />
// 					</ProtectedBusinessRoute>
// 				} />
// 				<Route path="manage-media" element={
// 					<ProtectedBusinessRoute ownerOnly>
// 						<BusinessManageMedia />
// 					</ProtectedBusinessRoute>
// 				} />
// 				<Route path="subaccounts" element={
// 					<ProtectedBusinessRoute ownerOnly>
// 						<SubaccountsManagement />
// 					</ProtectedBusinessRoute>
// 				} />
// 				<Route path="subaccount-profile" element={<SubaccountProfile />} />
// 				<Route path="events" element={
// 					<ProtectedBusinessRoute ownerOnly>
// 						<EventManagement />
// 					</ProtectedBusinessRoute>
// 				} />
// 			</Route>
// 			<Route path="/" element={<Home />} />
// 			<Route path="/login" element={<Login />} />
// 			<Route path="/profile" element={<Profile />} />
// 			<Route path="/register" element={<Register />} />
// 			<Route path="/otp-sent" element={<OTPSent />} />
// 			<Route path="/stores" element={<Offer />} />
// 			<Route path="/store/:store_id" element={<StorePage />} />
// 			<Route path="/suggest-store" element={<SuggestStore />} />
// 			<Route path="/offer/:offer_id" element={<SingleOffer />} />
// 			<Route path="/about" element={<About />} />
// 			<Route path="/charity" element={<Charity />} />
// 			<Route path="/rewards" element={<Rewards />} />
// 			<Route path="/donation" element={<Donation />} />
// 			<Route path="/donation-payment-1" element={<DonationPayment1 />} />
// 			<Route path="/donation-payment-2" element={<DonationPayment2 />} />
// 			<Route
// 				path="/donation-payment-razorpay"
// 				element={<DonationPaymentRazorpay />}
// 			/>
// 			<Route path="/donation-special" element={<DonationSpecial />} />
// 			<Route
// 				path="/loyalty-card-profile"
// 				element={<LoyaltyCardProfile />}
// 			/>
// 			<Route path="/payment-gateway" element={<PaymentPage />} />
// 			<Route path="/payment-success" element={<PaymentSuccess />} />
// 			<Route path="/payment-failure" element={<PaymentFailure />} />
// 			<Route path="/profile" element={<Profile />}>
// 				<Route path="dashboard" element={<Dashboard />} />
// 				<Route path="account" element={<Account />} />
// 				<Route path="transaction" element={<Transaction />} />
// 				<Route
// 					path="account/edit-personal-info"
// 					element={<EditPersonalInfo />}
// 				/>
// 				<Route path="account/edit-address" element={<EditAddress />} />
// 				<Route path="security" element={<Security />} />
// 				<Route path="support" element={<CustomerSupport />} />
// 			</Route>
// 			<Route path="/admin" element={<AdminLayout />}>
// 				<Route index element={<DashboardAdmin />} />
// 				<Route path="dashboard" element={<DashboardAdmin />} />
// 				<Route path="transactions" element={<TransactionsAdmin />} />
// 				<Route path="accounts" element={<AccountsAdmin />} />
// 				<Route path="services" element={<ServicesAdmin />} />
// 				<Route path="privileges" element={<PrivilegesAdmin />} />
// 				<Route path="settings" element={<SettingsAdmin />} />
// 				<Route
// 					path="charity-management"
// 					element={<CharityManagement />}
// 				/>
// 			</Route>
// 			<Route
// 				path="/recommended-brands/:store_id"
// 				element={<RecommendedBrands />}
// 				/>
// 			<Route
// 				path="/developers-not-found"
// 				element={<DevelopersNotFound />}
// 			/>
// 			<Route path="*" element={<NotFound />} />

// 			<Route path="/volunteer/*" element={<VolunteerLayout />}>
// 				<Route index element={<Navigate to="stores" replace />} />
// 				<Route path="stores" element={<VolunteerStores />} />
// 			</Route>
// 			<Route path="/volunteering" element={<Volunteering />} />

// 		</Routes>
// 	);
// };

// export default AppRoute;
//
import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedBusinessRoute from "./components/ProtectedBusinessRoute";
import ProtectedRoute from "./protectedRoute";
import PageLoader from "./components/PageLoader";

const Home = lazy(() => import("./pages/Home"));
const Profile = lazy(() => import("./pages/Profile"));
const Register = lazy(() => import("./pages/Register"));
const OTPSent = lazy(() => import("./pages/OTPSent"));
const Offer = lazy(() => import("./pages/PartnersAndRewards"));
const SingleOffer = lazy(() => import("./pages/SingleOffer"));
const About = lazy(() => import("./pages/About"));
const Charity = lazy(() => import("./pages/LoveAllMedia"));
const Donation = lazy(() => import("./pages/Donation"));
const DonationPayment1 = lazy(() => import("./pages/DonationPayment1"));
const DonationPayment2 = lazy(() => import("./pages/DonationPayment2"));
const DonationPaymentRazorpay = lazy(() => import("./pages/DonationPaymentRazorpay"));
const DonationSpecial = lazy(() => import("./pages/DonationSpecial"));
const Volunteering = lazy(() => import("./pages/Volunteering"));
const NotFound = lazy(() => import("./pages/NotFound"));
const DevelopersNotFound = lazy(() => import("./pages/DevelopersNotFound"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Account = lazy(() => import("./pages/Account"));
const EditPersonalInfo = lazy(() => import("./pages/EditPersonalInfo"));
const EditAddress = lazy(() => import("./pages/EditAddress"));
const Security = lazy(() => import("./pages/Security"));
const CustomerSupport = lazy(() => import("./pages/CustomerSupport"));
const LoyaltyCardProfile = lazy(() => import("./pages/DonateAndJoin"));
const PaymentPage = lazy(() => import("./pages/PaymentPage"));
const Transaction = lazy(() => import("./pages/Transaction"));
const Business = lazy(() => import("./pages/Business/Business"));
const BusinessDashboard = lazy(() => import("./pages/Business/BusinessDashboard"));
const BusinessProfileStores = lazy(() => import("./pages/Business/BusinessProfileStores"));
const BusinessAddStore = lazy(() => import("./pages/Business/BusinessAddStore"));
const BusinessProfileStoreEdit = lazy(() => import("./pages/Business/BusinessProfileStoreEdit"));
const OffersManagement = lazy(() => import("./pages/Business/RewardsManagement"));
const Feedback = lazy(() => import("./pages/Business/Feedback"));
const BusinessTransaction = lazy(() => import("./pages/Business/BusinessTransaction"));
const QrCodeBusiness = lazy(() => import("./pages/Business/QrCodeBusiness"));
const QrScannerBusiness = lazy(() => import("./pages/Business/QrScannerBusiness"));
const BusinessEditProfile = lazy(() => import("./pages/Business/BusinessEditProfile"));
const BusinessManageMedia = lazy(() => import("./pages/Business/BusinessManageMedia"));
const AccountsLayout = lazy(() => import("./pages/Accounts/AccountsLayout"));
const AccountsDashboard = lazy(() => import("./pages/Accounts/AccountsDashboard"));
const AccountsProfile = lazy(() => import("./pages/Accounts/AccountsProfile"));
const AccountsTransactions = lazy(() => import("./pages/Accounts/AccountsTransactions"));
const AdminLayout = lazy(() => import("./pages/Admin/AdminLayout"));
const DashboardAdmin = lazy(() => import("./pages/Admin/DashboardAdmin"));
const TransactionsAdmin = lazy(() => import("./pages/Admin/TransactionsAdmin"));
const AccountsAdmin = lazy(() => import("./pages/Admin/AccountsAdmin"));
const ServicesAdmin = lazy(() => import("./pages/Admin/ServicesAdmin"));
const PrivilegesAdmin = lazy(() => import("./pages/Admin/PrivilegesAdmin"));
const SettingsAdmin = lazy(() => import("./pages/Admin/SettingsAdmin"));
const CharityManagement = lazy(() => import("./pages/Admin/CharityManagement"));
const QueriesAdmin = lazy(() => import("./pages/Admin/QueriesAdmin"));
const RecommendedBrands = lazy(() => import("./pages/RecommendedBrands"));
const CustomerInsights = lazy(() => import("./pages/Business/CustomerInsights"));
const ContactSupport = lazy(() => import("./pages/Business/ContactSupport"));
const BusinessInfo = lazy(() => import("./pages/Business/BusinessInfo"));
const Login = lazy(() => import("./components/Login"));
const SubaccountsManagement = lazy(() => import("./pages/Business/SubaccountsManagement"));
const SubaccountProfile = lazy(() => import("./pages/Business/SubaccountProfile"));
const EventManagement = lazy(() => import("./pages/Business/EventManagement"));
const PaymentSuccess = lazy(() => import("./pages/PaymentSuccess"));
const PaymentFailure = lazy(() => import("./pages/PaymentFailure"));
const StorePage = lazy(() => import("./pages/StorePage"));
const SuggestStore = lazy(() => import("./pages/SuggestStore"));
const MyQr = lazy(() => import("./pages/MyQr"));
const MemberBenefitsInfo = lazy(() => import("./pages/MemberBenefitsInfo"));
const BusinessBenefitsInfo = lazy(() => import("./pages/BusinessBenefitsInfo"));
const CompanyBenefitsInfo = lazy(() => import("./pages/CompanyBenefitsInfo"));
const OurWork = lazy(() => import("./pages/OurWork"));
const Contact = lazy(() => import("./pages/Contact"));
const Terms = lazy(() => import("./pages/Terms"));
const Privacy = lazy(() => import("./pages/Privacy"));
const Faq = lazy(() => import("./pages/Faq"));
const VolunteerLayout = lazy(() => import("./pages/volunteer/VolunteerLayout"));
const VolunteerStores = lazy(() => import("./pages/volunteer/VolunteerStores"));
// import BusinessProfile from "./pages/Business/BusinessProfile"; // [DEPRECATED]

// import VolunteerDashboard from "./pages/volunteer/volunteerDashboard";
// import VolunteerProfile from "./pages/volunteer/volunteerProfile";

const AppRoute = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
      <Route path="/business" element={<ProtectedRoute allowedAuthTypes={["business", "subaccount"]}><Business /></ProtectedRoute>}>
        <Route index element={<BusinessDashboard />} />
        {/* <Route path="profile" element={<BusinessProfile />} />  // [DEPRECATED] */}
        <Route
          path="stores"
          element={
            <ProtectedBusinessRoute allowedRoles={["Admin", "Manager"]}>
              <BusinessProfileStores />
            </ProtectedBusinessRoute>
          }
        />
        <Route
          path="stores/add"
          element={
            <ProtectedBusinessRoute allowedRoles={["Admin", "Manager"]}>
              <BusinessAddStore />
            </ProtectedBusinessRoute>
          }
        />
        <Route
          path="stores/edit/:storeId"
          element={
            <ProtectedBusinessRoute allowedRoles={["Admin", "Manager"]}>
              <BusinessProfileStoreEdit />
            </ProtectedBusinessRoute>
          }
        />
        <Route
          path="rewards"
          element={
            <ProtectedBusinessRoute allowedRoles={["Admin", "Manager"]}>
              <OffersManagement />
            </ProtectedBusinessRoute>
          }
        />
        <Route path="feedback" element={<Feedback />} />
        <Route path="transactions" element={<BusinessTransaction />} />
        <Route
          path="insights"
          element={
            <ProtectedBusinessRoute allowedRoles={["Admin", "Manager"]}>
              <CustomerInsights />
            </ProtectedBusinessRoute>
          }
        />
        <Route path="contact" element={<ContactSupport />} />
        <Route
          path="info"
          element={
            <ProtectedBusinessRoute ownerOnly>
              <BusinessInfo />
            </ProtectedBusinessRoute>
          }
        />
        <Route path="qr-code/:offerId" element={<QrCodeBusiness />} />
        <Route path="qr-scanner" element={<QrScannerBusiness />} />
        <Route
          path="edit-profile"
          element={
            <ProtectedBusinessRoute ownerOnly>
              <BusinessEditProfile />
            </ProtectedBusinessRoute>
          }
        />
        <Route
          path="manage-media"
          element={
            <ProtectedBusinessRoute ownerOnly>
              <BusinessManageMedia />
            </ProtectedBusinessRoute>
          }
        />
        <Route
          path="subaccounts"
          element={
            <ProtectedBusinessRoute ownerOnly>
              <SubaccountsManagement />
            </ProtectedBusinessRoute>
          }
        />
        <Route path="subaccount-profile" element={<SubaccountProfile />} />
        <Route
          path="events"
          element={
            <ProtectedBusinessRoute ownerOnly>
              <EventManagement />
            </ProtectedBusinessRoute>
          }
        />
      </Route>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/profile" element={<ProtectedRoute allowedAuthTypes={["user"]}><Profile /></ProtectedRoute>} />
      <Route path="/register" element={<Register />} />
      <Route path="/my-qr" element={<ProtectedRoute allowedAuthTypes={["user"]}><MyQr /></ProtectedRoute>} />
      <Route path="/otp-sent" element={<OTPSent />} />
      <Route path="/partners-and-rewards" element={<Offer />} />
      <Route path="/store/:store_id" element={<StorePage />} />
      <Route path="/suggest-store" element={<SuggestStore />} />
      <Route path="/offer/:offer_id" element={<SingleOffer />} />
      <Route path="/about" element={<About />} />
      <Route path="/our-work" element={<OurWork />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/loveall-media" element={<Charity />} />
      <Route path="/rewards" element={<Offer />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/donation" element={<Donation />} />
      <Route path="/donation-payment-1" element={<DonationPayment1 />} />
      <Route path="/donation-payment-2" element={<DonationPayment2 />} />
      <Route
        path="/donation-payment-razorpay"
        element={<DonationPaymentRazorpay />}
      />
      <Route path="/donation-special" element={<DonationSpecial />} />
      <Route path="/donate-and-join" element={<LoyaltyCardProfile />} />
      <Route path="/payment-gateway" element={<PaymentPage />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-failure" element={<PaymentFailure />} />
      <Route path="/profile" element={<ProtectedRoute allowedAuthTypes={["user"]}><Profile /></ProtectedRoute>}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="account" element={<Account />} />
        <Route path="transaction" element={<Transaction />} />
        <Route
          path="account/edit-personal-info"
          element={<EditPersonalInfo />}
        />
        <Route path="account/edit-address" element={<EditAddress />} />
        <Route path="security" element={<Security />} />
        <Route path="support" element={<CustomerSupport />} />
      </Route>
      <Route path="/admin" element={<ProtectedRoute allowedAuthTypes={["admin"]}><AdminLayout /></ProtectedRoute>}>
        <Route index element={<DashboardAdmin />} />
        <Route path="dashboard" element={<DashboardAdmin />} />
        <Route path="transactions" element={<TransactionsAdmin />} />
        <Route path="accounts" element={<AccountsAdmin />} />
        <Route path="services" element={<ServicesAdmin />} />
        <Route path="privileges" element={<PrivilegesAdmin />} />
        <Route path="settings" element={<SettingsAdmin />} />
        <Route path="charity-management" element={<CharityManagement />} />
        <Route path="queries" element={<QueriesAdmin />} />
      </Route>
      <Route path="/accounts" element={<ProtectedRoute allowedAuthTypes={["accounts", "account"]}><AccountsLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AccountsDashboard />} />
        <Route path="transactions" element={<AccountsTransactions />} />
        <Route path="profile" element={<AccountsProfile />} />
      </Route>
      <Route
        path="/recommended-brands/:store_id"
        element={<RecommendedBrands />}
      />
      <Route path="/member-benefits-info" element={<MemberBenefitsInfo />} />
      <Route path="/business-benefits-info" element={<BusinessBenefitsInfo />} />
      <Route path="/company-benefits-info" element={<CompanyBenefitsInfo />} />
      <Route path="/developers-not-found" element={<DevelopersNotFound />} />
      <Route path="*" element={<NotFound />} />

      <Route path="/volunteer/*" element={<ProtectedRoute allowedAuthTypes={["volunteer"]}><VolunteerLayout /></ProtectedRoute>}>
        <Route index element={<Navigate to="stores" replace />} />
        <Route path="stores" element={<VolunteerStores />} />
      </Route>
      <Route path="/volunteering" element={<Volunteering />} />
    </Routes>
    </Suspense>
  );
};

export default AppRoute;
